import { styled } from '@mui/material';
import Box from '@mui/material/Box';

export const Wrapper = styled(Box)(({ theme }) => ({
	width: `calc(100% - ${theme.sizes.avatar.small}px)`,
	paddingLeft: theme.spacing(2),
	zIndex: theme.zIndex.appBar,
}));
